
export class NovoSistemaCadastroFormModel {
    constructor(
        public nome: string = '',
        public descricao: string = '',
        public urlImagem: string = '',
        public permiteMultiContratos: boolean = false
    ) { }
}